import '../../styles/ObservationDashboard';
import _ from 'lodash';
import LoadingScreen from '../../../shared/js/components/LoadingScreen';
import LoadingSpinner from '../../../shared/js/components/LoadingSpinner';
import moment from 'moment';
import DashboardOverview from './DashboardOverview';
import DashboardStudentDetails from './DashboardStudentDetails';
import DashboardStudentOverview from './DashboardStudentOverview';
import DashboardTeacherDetails from './DashboardTeacherDetails';
import React, { PropTypes } from 'react';
import SelectDistrictSchoolAndClassroom from '../../../a2i/js/components/SelectDistrictSchoolAndClassroom';
import { fetchJson } from '../actions/index';
import { Modal } from 'react-bootstrap';
import { propertyHasChanged } from '../../../a2i/js/lib/objectComparison';
import { pluralize } from '../../../a2i/js/lib/stringFormatter';


let ObservationDashboard = React.createClass({
	propTypes: {
		isFetchingEventTypes: PropTypes.bool,
		isFetchingShallowObservations: PropTypes.bool,
		fetchStudentEventTypes: PropTypes.func.isRequired,
		fetchTeacherEventTypes: PropTypes.func.isRequired,
		selectedClassroom: PropTypes.object,
		studentEventTypes: PropTypes.array,
		teacherEventTypes: PropTypes.array,
		params: PropTypes.shape({
			observationId: PropTypes.string,
			section: PropTypes.string,
			studentId: PropTypes.string
		})
	},

	contextTypes: {
		router: PropTypes.object.isRequired
	},

	getInitialState: function() {
		return {
			hasFetchedShallowObservations: false,
			isFetchingShallowObservations: false,
			isShowingGlossary: false,
			observation: null,
			observations: []
		};
	},

	componentWillMount: function() {
		this.props.fetchStudentEventTypes();
		this.props.fetchTeacherEventTypes();

		if (this.props.selectedClassroom) {
			this.fetchShallowObservations(this.props.selectedClassroom.id);
		}

		if (this.props.params.observationId) {
			this.fetchObservation(this.props.params.observationId);
		}
	},

	componentWillReceiveProps: function(newProps) {
		if (newProps.selectedClassroom && propertyHasChanged(this.props.selectedClassroom, newProps.selectedClassroom)) {
			if (this.state.observation) {
				const isObservationClassroom = newProps.selectedClassroom.id === this.state.observation.classroom_id;

				if (!isObservationClassroom) {
					this.context.router.push('/dashboard');
				}
			}

			this.setState({ hasFetchedShallowObservations: false });
			this.fetchShallowObservations(newProps.selectedClassroom.id);
		}

		if (newProps.params.observationId) {
			if (newProps.params.observationId !== this.props.params.observationId) {
				this.fetchObservation(newProps.params.observationId);
			}
		} else {
			this.setState({ observation: null });
		}
	},

	componentDidUpdate: function() {
		this.initializeDropdown();
	},

	fetchShallowObservations: function(classroomId) {
		this.setState({ isFetchingShallowObservations: true });
		fetchJson('/api/observations/shallow?classroom_id=' + classroomId).then((response) => {
			this.setState({ isFetchingShallowObservations: false });

			if (response && response.data && response.data.list) {
				this.setState({ observations: response.data.list });
			}
		}).then(() => {
			this.setState({ isFetchingShallowObservations: false, hasFetchedShallowObservations: true });
		});
	},

	fetchObservation: function(observationId) {
		fetchJson('/api/observations/' + observationId + '/details').then((response) => {
			if (response.data) {
				this.setState({ observation: response.data });
			}
		});
	},

	handleSelectObservation: function(observationId) {
		// TODO: store selected observation ID in localStorage
		if (observationId && observationId !== this.props.params.observationId) {
			this.context.router.push('/dashboard/' + observationId);
		}
	},

	getDashboardContent: function() {
		if (!this.state.observation) {
			return '';
		}

		if (this.props.params.studentId && this.props.studentEventTypes && this.props.teacherEventTypes) {
			return (
				<DashboardStudentDetails
					observation={ this.state.observation }
					router={ this.context.router }
					studentEventTypes={ this.props.studentEventTypes }
					studentId={ parseInt(this.props.params.studentId) }
				/>
			);
		} else if (this.props.params.section) {
			switch(this.props.params.section) {
				case 'students':
					return (
						<DashboardStudentOverview
							observation={ this.state.observation }
							router={ this.context.router }
						/>
					);
				case 'teacher':
					return (
						<DashboardTeacherDetails
							observation={ this.state.observation }
							router={ this.context.router }
							teacherEventTypes={ this.props.teacherEventTypes }
						/>
					);
			}
		} else {
			return (
				<DashboardOverview
					observation={ this.state.observation }
					router={ this.context.router }
					studentEventTypes={ this.props.studentEventTypes }
					teacherEventTypes={ this.props.teacherEventTypes }
				/>
			);
		}
	},

	initializeDropdown: function() {
		$('.observation-dashboard .select-observation .ui.dropdown').dropdown({
			action: 'hide',
			onChange: this.handleSelectObservation,
			placeholder: 'Choose an observation',
		});

		if (this.props.params.observationId) {
			$('.observation-dashboard .select-observation .ui.dropdown').dropdown('set selected', this.props.params.observationId);
		} else {
			$('.observation-dashboard .select-observation .ui.dropdown').dropdown('clear');
		}
	},

	isObservationSelectionDisabled: function() {
		return this.props.isFetchingShallowObservations;
	},

	render: function() {
		return (
			<div className="observation-dashboard">
				<div className="show-glossary btn btn-info" onClick={ () => this.setState({ isShowingGlossary: true }) }>
					<i className="far fa-question-circle" />{' '}Glossary
				</div>
				<SelectDistrictSchoolAndClassroom />
				{
					this.props.selectedClassroom || this.state.observation ? (
						<div className="select-observation">
							<div className={ 'ui floating dropdown labeled search icon button fluid' + (this.isObservationSelectionDisabled() ? ' disabled' : '') }>
								<i />
								<div className="icon-left"><i className="fas fa-eye" /></div>
								<div className="default text">Choose an observation</div>
								<div className="menu">
									{
										this.state.observations ? (
											_.sortBy(this.state.observations, 'created_at').reverse().map((observation, index) => {
												return (
													<div
														className="item"
														data-value={ observation.id }
														key={ 'select-observation-option-' + observation.id + '-' + Math.random() }
													>
														#{ observation.id + ' on ' + moment(observation.created_at).format('ddd MMM Do, YYYY') } at { moment(observation.created_at).format('H:mma') }
														{' '}
														({ pluralize(observation.number_of_cycles, 'cycle') } of {observation.student_minutes} student minutes and {observation.teacher_minutes} teacher minutes)
													</div>
												);
											})
										) : ''
									}
								</div>
								<div className="icon-right">
									{
										this.props.isFetchingShallowObservations ? (
											<LoadingSpinner />
										) : (
											<i className="fas fa-caret-down" />
										)
									}
								</div>
							</div>
						</div>
					) : ''
				}

				{ this.getDashboardContent() }

				{
					this.state.isFetchingShallowObservations || this.props.isFetchingEventTypes ? (
						<LoadingScreen message="Loading" />
					) : ''
				}
				{
					this.props.selectedClassroom && this.state.hasFetchedShallowObservations && !this.state.observations || this.state.observations.length === 0 ? (
						<div className="none-found">No observations have been performed for this classroom</div>
					) : ''
				}
				<Modal
					className="glossary-modal"
					onHide={ () => this.setState({ isShowingGlossary: false }) }
					show={ this.state.isShowingGlossary }
					bsSize="lg"
				>
					<Modal.Header
						closeButton={ true }
						onHide={ () => this.setState({ isShowingGlossary: false }) }
					>
						<h2>Glossary</h2>
					</Modal.Header>
					<Modal.Body>
						<table className="table table-striped">
							<thead>
								<tr>
									<th>Abbreviation</th>
									<th>Meaning</th>
									<th>Explanation</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="abbreviation">T/CM</td>
									<td className="meaning">Teacher/Child-Managed</td>
									<td className="explanation">Instruction managed by the teacher and child together</td>
								</tr>
								<tr>
									<td className="abbreviation">PM</td>
									<td className="meaning">Peer-Managed</td>
									<td className="explanation">Child and peers working together</td>
								</tr>
								<tr>
									<td className="abbreviation">CM</td>
									<td className="meaning">Child-Managed</td>
									<td className="explanation">Instruction managed by the child alone</td>
								</tr>
								<tr>
									<td className="abbreviation">WC</td>
									<td className="meaning">Whole Class</td>
									<td className="explanation">Entire class taught by the teacher at the same time</td>
								</tr>
								<tr>
									<td className="abbreviation">SG</td>
									<td className="meaning">Small Group</td>
									<td className="explanation">Small group (2-8 children) context</td>
								</tr>
								<tr>
									<td className="abbreviation">Indiv</td>
									<td className="meaning">Individual</td>
									<td className="explanation">Child was working alone</td>
								</tr>
								<tr>
									<td className="abbreviation">MF</td>
									<td className="meaning">Meaning-Focused</td>
									<td className="explanation">Focused on vocabulary and the meanings of words</td>
								</tr>
								<tr>
									<td className="abbreviation">CF</td>
									<td className="meaning">Code-Focused</td>
									<td className="explanation">Focused on decoding skills</td>
								</tr>
							</tbody>
						</table>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
});

module.exports = ObservationDashboard;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/ObservationDashboard.jsx